module.exports = __webpack_public_path__ + "static/media/1.Full Range of Hand tools.88c40b5b.jpg";